import PaymentSourceSection from './PaymentSourceSection';

export default PaymentSourceSection;